// extracted by mini-css-extract-plugin
module.exports = {"TitleCard":"styles_TitleCard__3_yL5"};